module.exports = __webpack_public_path__ + "static/media/integrations.mobile.05ff6356.svg";